export const isValidEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

/** Check if contact number is valid (10 digits for South Africa) */
export const isValidContactNumber = (number: string): boolean => {
  return /^\d{10}$/.test(number);
};

/** Check if identification number is not empty */
export const isValidIdentificationNumber = (id: string): boolean => {
  return id.trim().length > 0;
};
